module.exports = __webpack_public_path__ + "assets/img/13fee88bd881bdb64b6caa7add3c29cc.png";